/**
 * Diagnostics API schemas
 */

import { z } from 'zod';

/**
 * Environment variables response
 */
export const EnvironmentVariablesResponseSchema = z.record(z.string(), z.string());

/**
 * AWS credentials response
 */
export const AwsCredentialsResponseSchema = z.object({
    AccessKeyId: z.string().optional(),
    SecretAccessKey: z.string().optional(),
    Token: z.string().optional(),
    Expiration: z.string().optional(),
    error: z.string().optional(),
});

/**
 * Get caller identity response
 */
export const GetCallerIdentityResponseSchema = z.object({
    Account: z.string().optional(),
    Arn: z.string().optional(),
    UserId: z.string().optional(),
    error: z.string().optional(),
});

/**
 * Get system info response
 */
export const GetSystemInfoResponseSchema = z.object({
    nodeVersion: z.string(),
    platform: z.string(),
    uptime: z.number(),
    uptimeFormatted: z.string(),
    memoryUsage: z.object({
        rss: z.number(),
        heapTotal: z.number(),
        heapUsed: z.number(),
        external: z.number(),
        arrayBuffers: z.number(),
    }),
    memoryUsageFormatted: z.object({
        rss: z.string(),
        heapTotal: z.string(),
        heapUsed: z.string(),
        external: z.string(),
        arrayBuffers: z.string(),
    }),
});

/**
 * Get SES diagnostics response
 */
export const GetSesDiagnosticsResponseSchema = z.object({
    sendQuota: z
        .object({
            Max24HourSend: z.number(),
            MaxSendRate: z.number(),
            SentLast24Hours: z.number(),
        })
        .optional(),
    sendQuotaError: z.string().optional(),
    identityVerification: z
        .record(
            z.string(),
            z.object({
                VerificationStatus: z.string().optional(),
                VerificationToken: z.string().optional(),
            })
        )
        .optional(),
    identityVerificationError: z.string().optional(),
});
